// extracted by mini-css-extract-plugin
export default {"requiredMark":"Form_requiredMark__Vd2Uq"};